import * as service from './service'
export default {
  namespace: 'honourKnightKnightRankingList',
  state: {
    demoData: {}
  },
  effects: {
    * rankJoin ({ payload }, { call, put }) {
      const res = yield call(service.demo, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
